<div class="container-fluid">
<app-report-select header="Monthly Statement"  [reports]="true"
  [consumer]="false"
  [showSingleDate]="true"
  [Month_Year]="true"
  [showSites]="true"
  [FromToLocation]="true"
  [showDaterange]="false"
  [showLocation]="false"
  [AllSelection]="false"
 (filtersApplied)="handleFilters($event)" (showTable)="handlereset($event)"></app-report-select>    
    <div class="row" *ngIf="!pdfDoc">
        <img src="assets/DashboardIcon/applyfilters.svg" alt="" height="300px" width="400px">
    </div>
<div class="pdf-holder" *ngIf="pdfDoc">

  <!-- Header -->
  <div class="pdf-header">
    <div class="pdf-header-icon">
      <svg viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/></svg>
    </div>
    <span class="pdf-header-title">Monthly Electricity Statement</span>
    <span class="pdf-header-badge">PDF PREVIEW</span>
  </div>

  <!-- Controls -->
  <div class="pdf-controls">
    <div class="pdf-nav">
      <button class="btn-nav" (click)="prevPage()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="15 18 9 12 15 6"/></svg>
        Prev
      </button>
      <div class="pdf-page-indicator">
        Page <span>{{ currentPage }}</span> / <span>{{ totalPages }}</span>
      </div>
      <button class="btn-nav" (click)="nextPage()">
        Next
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>
      </button>
    </div>
    <button class="btn-download" (click)="pdfDownload()">
      <svg viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5">
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
        <polyline points="7 10 12 15 17 10"/>
        <line x1="12" y1="15" x2="12" y2="3"/>
      </svg>
      Download
    </button>
  </div>

  <!-- Canvas -->
  <div class="pdf-canvas-area">
    <div class="pdf-canvas-wrap">
      <canvas #pdfCanvas></canvas>
    </div>
  </div>

  <!-- Footer -->
  <div class="pdf-footer">
    <div class="pdf-footer-meta">
      <span>Date: {{date}}</span>
      <span>Flats: {{flatString}}</span>
    </div>
    <span class="pdf-footer-logo">XENIUS</span>
  </div>

</div>
</div>